<div>
  <button
    #btn
    type="button"
    [id]="identifier"
    [ngClass]="{
      'toggle-button': true,
      'toggle-button--enabled': isOn
    }"
    (click)="onClick($event)"
    [attr.aria-label]="showTooltip && (isOn ? tooltips?.on : tooltips?.off || tooltips?.on)"
    ftrTooltip
    [message]="(isOn ? tooltips?.on : tooltips?.off) ?? 'Unknown'"
    [showDash]="false"
    [forceDisplayState]="tooltips && showTooltip ? undefined : tooltipDisplay.Hide"
    [attr.data-test-id]="testId"
  >
    <ftr-icon [icon]="isOn ? icons.on : icons.off" align="Middle"></ftr-icon>
  </button>
</div>
